import {
  booking_black,
  dashboard,
  dashboard_black,
  vehicle,
  settings,
  driver,
  driver_black,
  setting_black,
  records,
  vehicle_black,
  records_black,
  bookings,
  manage_partner,
  manage_partner_black,
  finance_black,
  finance,
  staff_black,
  staff,
} from "../assets";

export const reactBackendUrl = process.env.REACT_APP_BACKEND_URL;
// export const reactBackendUrl = 'http://localhost:8000/';

export const handleShowPickUpPoint = async (
  pick_up_location,
  drop_off_location
) => {
  if (pick_up_location && drop_off_location) {
    const encodedPickUpLocation = encodeURIComponent(pick_up_location);
    const encodedDropOffLocation = encodeURIComponent(drop_off_location);
    const googleMapsUrl = `https://www.google.com/maps/dir/${encodedPickUpLocation}/${encodedDropOffLocation}`;
    window.open(googleMapsUrl, "_blank");
  }
};

export const formatDateString = (dateString) => {
  if (dateString === null) {
    return "";
  }
  var date = new Date(dateString);
  var formattedDate = date.toLocaleDateString().split("/").join("-");
  return formattedDate;
};

export const formatDate = (inputDate) => {
  const parsedDate = new Date(inputDate);
  const day = parsedDate.getDate();
  const month = parsedDate.toLocaleString("default", { month: "long" });
  const year = parsedDate.getFullYear();
  return `${day} ${month} ${year}`;
};

export const formatDateToDMY = (dateString) => {
  // 2024-08-21T00:00:00Z - accepts in this format
  if (dateString) {
    const date = new Date(dateString);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    // console.log(dateString, day, month, year);

    return `${day}.${month}.${year}`;
  } else {
    return "";
  }
};

export const sidebarItems = [
  {
    icon: dashboard_black,
    whiteIcon: dashboard,
    title: "Dashboard",
    hasSubmenu: false,
    path: "/",
  },
  {
    icon: booking_black,
    path: "/bookings",
    title: "Bookings",
    whiteIcon: bookings,
    hasSubmenu: true,
    submenuItems: [
      { title: "All bookings", image: bookings, path: "/bookings" },
      { title: "Create bookings", image: bookings, path: "/bookings/create" },
    ],
  },
  {
    icon: vehicle_black,
    whiteIcon: vehicle,
    title: "Vehicle Listing",
    hasSubmenu: false,
    path: "/vehicles",
  },
  {
    icon: records_black,
    whiteIcon: records,
    title: "Master Records",
    hasSubmenu: true,
    path: "/brands",
    submenuItems: [
      { title: "Brands", image: records, path: "/brands" },
      { title: "Model", image: records, path: "/brands/models" },
    ],
  },
  {
    icon: driver_black,
    path: "/drivers",
    whiteIcon: driver,
    title: "Manage Drivers",
    hasSubmenu: false,
  },
  {
    icon: manage_partner_black,
    path: "/partners",
    whiteIcon: manage_partner,
    title: "Manage Partners",
    hasSubmenu: false,
  },
  {
    icon: setting_black,
    title: "Settings",
    whiteIcon: settings,
    path: "/account",
    hasSubmenu: true,
    submenuItems: [
      { title: "Account Details", image: settings, path: "/account" },
      {
        title: "Change Password",
        image: settings,
        path: "/account/changepassword",
      },
    ],
  },
];

export const newSidebarItems = [
  {
    icon: dashboard_black,
    whiteIcon: dashboard,
    title: "Dashboard",
    hasSubmenu: false,
    path: "/",
    roles: ["admin", "staff",],
  },
  {
    icon: booking_black,
    path: "/bookings",
    title: "Bookings",
    whiteIcon: bookings,
    hasSubmenu: true,
    roles: ["admin", "staff", "partner"],
    submenuItems: [
      { title: "All bookings", image: bookings, path: "/bookings" },
      { title: "Create bookings", image: bookings, path: "/bookings/create" },
    ],
  },
  {
    icon: vehicle_black,
    whiteIcon: vehicle,
    title: "Vehicle Listing",
    hasSubmenu: false,
    path: "/vehicles",
    roles: ["admin", "staff"],
  },
  {
    icon: records_black,
    whiteIcon: records,
    title: "Master Records",
    hasSubmenu: true,
    path: "/brands",
    roles: ["admin", "staff"],
    submenuItems: [
      { title: "Brands", image: records, path: "/brands" },
      { title: "Model", image: records, path: "/brands/models" },
    ],
  },
  {
    icon: driver_black,
    path: "/drivers",
    whiteIcon: driver,
    title: "Manage Drivers",
    hasSubmenu: false,
    roles: ["admin", "staff"],
  },
  {
    icon: manage_partner_black,
    path: "/partners",
    whiteIcon: manage_partner,
    title: "Manage Partners",
    hasSubmenu: true,
    roles: ["admin", "staff"],
    submenuItems: [
      { title: "Recievers", image: settings, path: "/partners/recievers" },
      {
        title: "Senders",
        image: settings,
        path: "/partners",
      },
    ],
  },
  // {
  //   icon: pricing_scheme_black,
  //   path: "/pricing",
  //   whiteIcon: pricing_scheme,
  //   title: "Pricing Scheme",
  //   hasSubmenu: false,
  // },
  {
    icon: finance_black,
    path: "/finance",
    whiteIcon: finance,
    title: "Finance",
    hasSubmenu: true,
    roles: ["admin", "staff"],
    submenuItems: [
      { title: "Booking Finance", image: finance, path: "/finance" },
      // {
      //   title: "Payouts",
      //   image: finance,
      //   path: "/finance/payouts",
      // },
      {
        title: "Payment History",
        image: finance,
        path: "/finance/bookinghistory",
      },
    ],
  },
  {
    icon: staff_black,
    path: "/staff",
    whiteIcon: staff,
    title: "Staff Management",
    hasSubmenu: false,
    roles: ["admin", "staff"],
  },
  {
    icon: setting_black,
    title: "Settings",
    whiteIcon: settings,
    path: "/account",
    hasSubmenu: true,
    roles: ["admin", "staff"],
    submenuItems: [
      { title: "Account Details", image: settings, path: "/account" },
      {
        title: "Change Password",
        image: settings,
        path: "/account/changepassword",
      },
    ],
  },
];

export const pathTitles = [
  { path: "/", title: "Dashboard" },
  { path: "/bookings", title: "Booking Listing" },
  { path: "/bookings/create", title: "Create Booking" },
  { path: "/booking/details", title: "Booking Details" },
  { path: "/vehicles", title: "Vehicle Listing" },
  { path: "/vehicles/create", title: "Add New Vehicle" },
  { path: "/brands", title: "Brands Listing" },
  { path: "/brands/create", title: "Add brand" },
  { path: "/brands/models", title: "Model Listing" },
  { path: "/brands/models/create", title: "Add model" },
  { path: "/drivers", title: "Manage Drivers" },
  { path: "/drivers/create", title: "Add Driver" },
  { path: "/partners", title: "Manage Partners" },
  { path: "/partners/create", title: "Add Partner" },
  { path: "/account", title: "Settings" },
  { path: "/account/changepassword", title: "Settings" },
  { path: "/pricing/create", title: "Pricing Scheme" },
  { path: "/pricing", title: "Pricing Scheme" },
];

export const newPathTitles = [
  { path: "/", title: "Dashboard" },
  { path: "/bookings", title: "Booking Listing" },
  { path: "/bookings/create", title: "Create Booking" },
  { path: "/booking/details", title: "Booking Details" },
  { path: "/vehicles", title: "Vehicle Listing" },
  { path: "/vehicles/create", title: "Add New Vehicle" },
  { path: "/brands", title: "Brands Listing" },
  { path: "/brands/create", title: "Add brand" },
  { path: "/brands/models", title: "Model Listing" },
  { path: "/brands/models/create", title: "Add model" },
  { path: "/drivers", title: "Manage Drivers" },
  { path: "/drivers/create", title: "Add Driver" },
  { path: "/partners", title: "Manage Partners (Senders)" },
  { path: "/partners/recievers", title: "Manage Partners (Recievers)" },
  { path: "/partners/create", title: "Add Partner" },
  { path: "/account", title: "Settings" },
  { path: "/account/changepassword", title: "Settings" },
  { path: "/finance/payments", title: "Finance - Payment" },
  { path: "/finance/payouts", title: "Finance - Payouts" },
];

export const vehicleClassOptions = [
  { value: "Economy", label: "Economy" },
  { value: "Economy Plus", label: "Economy+" },
  { value: "Business Van", label: "Business Van" },
  { value: "Business Sedan", label: "Business Sedan" },
  { value: "Sedan", label: "Sedan" },
  { value: "Minibus-10", label: "Minibus-10" },
  { value: "Minibus-12", label: "Minibus-12" },
  { value: "Minibus-14", label: "Minibus-14" },
  { value: "Minibus-16", label: "Minibus-16" },
  { value: "Minibus-18", label: "Minibus-18" },
  { value: "MPV4", label: "MPV4" },
];

export const truncateName = (value) => {
  if (value) {
    return value.length > 20 ? value.substring(0, 20) + "..." : value;
  }
  return "-";
};

export const selectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    boxShadow: "0px !important",
    border: "0px !important",
    height: "42px",
  }),
};

export const isValidFlightNumber = (str) => {
  let regex = new RegExp(/^[A-Z]{2}\s{0, 1}[0-9]{3, 4}$/);
  if (str === null || str.trim() === "") {
    return false;
  }
  return regex.test(str);
};

export const childSeatOptions = [
  { value: null, label: "-" },
  { value: "NINE_EIGHTEEN", label: "|: 9 - 18 kg" },
  { value: "FIFTEEN_TWENTYFIVE", label: "|| : 15 - 25 kg" },
  { value: "TWENTYFIVE_THIRTYSIX", label: "||| : 22 - 36 kg" },
  { value: "NINE_THIRTYSIX", label: "|/||/||| : 9 - 36 kg" },
  { value: "FIFTEEN_THIRTYSIX", label: "||/||| : 15 - 36 kg" },
];

export const initialAvailabilityData = [
  {
    day: "MON",
    availability: [],
  },
  {
    day: "TUE",
    availability: [],
  },
  {
    day: "WED",
    availability: [],
  },
  {
    day: "THU",
    availability: [],
  },
  {
    day: "FRI",
    availability: [],
  },
  {
    day: "SAT",
    availability: [],
  },
  {
    day: "SUN",
    availability: [],
  },
];

// "12 AM",
// "1 AM",
// "2 AM",
// "3 AM",
// "4 AM",
// "5 AM",
// "6 AM",
// "7 AM",
// "8 AM",
// "9 AM",
// "10 AM",
// "11 AM",
// "12 PM",
// "1 PM",
// "2 PM",
// "3 PM",
// "4 PM",
// "5 PM",
// "6 PM",
// "7 PM",
// "8 PM",
// "9 PM",
// "10 PM",
// "11 PM",

export const constructWhatsappMessage = (item, type) => {
  const primaryPassenger = item?.passengers_array?.filter(
    (passenger) => passenger.type === "Primary"
  )[0];

  if (!primaryPassenger) return "";

  const name = primaryPassenger.name || "N/A";
  const surname = primaryPassenger.surname || "";
  const phone = "+" + (primaryPassenger.phone || "N/A");
  const flightNumber =
    item?.flight_train_number !== null ? item?.flight_train_number : "N/A";

  const totalPassengers = item?.passengers_array?.length || 0;
  const totalLuggage =
    (item?.total_luggage_5_18kg || 0) +
    (item?.total_luggage_15_25kg || 0) +
    (item?.total_luggage_20_36kg || 0);

  // Passenger names for driver type message
  const passengerNames =
    item?.passengers_array
      ?.map((passenger) => `${passenger.name} ${passenger.surname}`)
      .join(", ") || "N/A";

  if (type === "driver") {
    const encodedDropOffLocation = encodeURIComponent(
      item?.drop_off_location || "N/A"
    );
    const dropOffLocationUrl = `https://www.google.com/maps/dir/${encodedDropOffLocation}`;
    const partner_name = item?.partner_details?.company_name
      ? item?.partner_details?.company_name
      : "--";
    const driverMessage = ` Pick-up time : ${item.pick_up_time
      } TRT \n\nPick-up and drop location : ${item.pick_up_location} - ${item.drop_off_location
      }\n\nPartner name : ${partner_name}\n\nPassenger name : ${passengerNames}\n\nFlight-number : ${flightNumber} \n\nHotel Name : ${item.drop_off_location
      }\n\nHotel Location : ${encodeURIComponent(dropOffLocationUrl)} 
    `;

    return driverMessage.replace(/\n/g, "%0A");
  }

  const message = `
    Hello ${name} ${surname},\n\n
    Here are your booking details:\n
    Pickup Date and Time: ${formatDate(item.pickup_date)} at ${item.pick_up_time
    }\n
    Pickup Location: ${item.pick_up_location}\n
    Passenger Name: ${name} ${surname}\n
    Passenger Phone: ${phone}\n
    Number of Passengers: ${totalPassengers}\n
    Flight Number: ${flightNumber}\n
    Number of Suitcases: ${totalLuggage}
  `;

  return message.replace(/\n/g, "%0A");
};

export const locationLibraries = ["places"];

export const downloadFileWithCustomName = (url, fileName) => {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";

  xhr.onload = function () {
    if (this.status === 200) {
      var blob = this.response;
      var a = document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  xhr.send();
};

export const RenderAsterisk = () => {
  return <span className="text-primary"> * </span>;
};

export const preventInvalidNumberInput = (e) => {
  if (["e", "E", "-", "+"].includes(e.key)) {
    e.preventDefault();
  }
};

export const getMediaUrl = (url) => {
  if (!url) {
    return '';
  }

  if (url.startsWith("/media")) {
    return reactBackendUrl + url.replace(/\/+/g, "/").slice(1);
  }

  if (!url.startsWith("https://") && !url.startsWith("http://")) {
    return `${reactBackendUrl}${url.replace(/\/+/g, "/")}`;
  }

  return url;
};